<template>
  <div class="featured">
    <div class="sn-c-featured border rounded mb-3 bg-dark text-white" v-for="post in posts">
      <PostImage v-bind:mediaid="post.featured_media" v-bind:postimageurl="post.jetpack_featured_media_url" />
      <div class="sn-c-featured__title">
        <h2 v-html="post.title.rendered">{{ post.title.rendered }}</h2>
        <div v-html="post.excerpt.rendered">{{ post.excerpt.rendered }}</div>
        <router-link :to="{ name: 'post', params: { slug: post.slug }}" class="stretched-link text-light">Continue reading</router-link>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios';
import PostImage from '@/components/PostImage.vue';

export default {
  name: 'featured',
  components: {
    PostImage
  },
  data() {
    return {
      posts: [],
      errors: [],
      loading: false
    }
  },
  watch: {
    '$route': 'getFeatured'
  },
  methods: {
    getFeatured() {
      axios.get('https://wpapi.sharenote.com/wp-json/wp/v2/posts?per_page=1&categories=22')
      .then(response => {
        // JSON responses are automatically parsed.
        this.posts = response.data
      })
      .catch(e => {
        this.errors.push(e)
      })
    }
  },
  mounted() {
    this.getFeatured();
  }
}
</script>
